import { render, staticRenderFns } from "./demoMessageCard.vue?vue&type=template&id=305242d7&scoped=true"
import script from "./demoMessageCard.vue?vue&type=script&lang=js"
export * from "./demoMessageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305242d7",
  null
  
)

export default component.exports